import {QuestionType} from '../types/quiz.types';

export const normalizeQuestionType = (questionType: QuestionType): string => {
  if (questionType === QuestionType.MULTIPLE_RESPONSE) {
    return QuestionType.MULTIPLE_CHOICE;
  }

  return questionType;
};
